import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { ReactComponent as ProfileIcon } from "./icons/person-fill.svg";
import { ReactComponent as ProductIcon } from "./icons/basket.svg";
import Logo from "./icons/logo.jpg";
import { ReactComponent as WeIcon } from "./icons/person-arms-up.svg";
import { ReactComponent as LoginRegistrationIcon } from "./icons/LoginRegistrationIcon.svg";
import Login from "./features/Auth/Login/login.js";
import Profile from "./features/Auth/Profile/profile.js";
import Products from "./features/Products/products.js";
import Registration from "./features/Auth/Registration/registration.js";
import EmailConfirm from "./features/Auth/Login/email_confirmation.js";
import ProductProfile from "./features/Products/ProductProfile.js";
import RegistrationSuccess from "./features/Auth/Registration/RegistrationSuccess.js";
import MainPage from "./features/Main/MainPage.js";
import Order from "./features/Products/Order.js";
import AboutUs from "./features/AboutUs/AboutUs.js";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css"

export default function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const refreshToken = async () => {
    const refresh = localStorage.getItem("refresh_token");
    if (!refresh) return handleLogout();
  
    const res = await fetch("https://monkeprogrammer01.pythonanywhere.com/user/token/refresh/", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ refresh }),
    });
  
    if (res.ok) {
      const data = await res.json();
      localStorage.setItem("access_token", data.access);
      setIsAuthenticated(true);
    } else {
      handleLogout();
    }
  };
  

  useEffect(() => {
    const token = localStorage.getItem("access_token");
    if (!token) return;
  
    fetch("https://monkeprogrammer01.pythonanywhere.com/user", {
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => {
        if (res.ok) {
          setIsAuthenticated(true);
        } else if (res.status === 401) {
          refreshToken(); // пробуем обновить токен
        }
      })
      .catch(() => handleLogout()); // если сеть недоступна
  }, []);
  
  useEffect(() => {
    const interval = setInterval(() => {
      refreshToken();
    }, 9 * 60 * 1000);

    return () => clearInterval(interval);
  }, []);

  const handleLogin = () => {
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    localStorage.removeItem("access_token");
    setIsAuthenticated(false)
  }

  return (
    <>
      <Router>
        <Navbar isAuthenticated={isAuthenticated} />
        <Routes>
          <Route path="/" element={<MainPage />} />
          <Route path="/user/login" element={<Login onLogin={handleLogin} />} />
          <Route path="/email/confirm/:uidb64/:token" element={<EmailConfirm />} />
          <Route path="/user" element={<Profile onLogout={handleLogout} />} />
          <Route path="/products" element={<Products />} />
          <Route path="/user/registration" element={<Registration />} />
          <Route path="/product/:id" element={<ProductProfile />} />
          <Route path="/email/confirm" element={<RegistrationSuccess />} />
          <Route path="/user/customer-form" element={<Order />} />
          <Route path="/about-us" element={<AboutUs />} />
        </Routes>
      </Router>
    </>
  );
}

function Navbar({ isAuthenticated }) {
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const toggleDropdown = () => {
    setDropdownVisible((prev) => !prev);
  };

  return (
    <div className="menu">
      <Helmet>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Helmet>
      <Link to="/">
        <img src={Logo} id="logo" alt="Logo" />
      </Link>
      <nav className="navbar">
        <ul className="navbar-nav">
          <li>
            {isAuthenticated ? (
              <Link to="/user">
                <ProfileIcon /> Профиль
              </Link>
            ) : (
              <div className="dropdown">
                <button className="dropdown-button" onClick={toggleDropdown}>
                  <LoginRegistrationIcon /> Аккаунт
                </button>
                {dropdownVisible && (
                  <div className="dropdown-menu">
                    <Link to="/user/login" className="dropdown-item">
                      Войти
                    </Link>
                    <Link to="/user/registration" className="dropdown-item">
                      Создать
                    </Link>
                  </div>
                )}
              </div>
            )}
          </li>
        </ul>
        <ul className="navbar-nav">
          <li>
            <Link to="/products">
              <ProductIcon /> Товары
            </Link>
          </li>
        </ul>
        <ul className="navbar-nav">
          <li>
            <Link to="/about-us">
              <WeIcon /> О нас
            </Link>
          </li>
        </ul>
      </nav>
    </div>
  );
}
